import { createReducer } from "typesafe-actions";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import { Route } from "@mapmycustomers/shared/types/entity";
import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

import routeFieldModel, { RouteFieldName } from "@app/util/fieldModel/RouteFieldModel";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  Actions,
  applyUpcomingViewStateSettings,
  fetchUpcomingRoutes,
  initializeUpcomingView,
} from "./actions";

export const PAGE_SIZE = 20;

export interface UpcomingViewState {
  initializing: boolean;
  loading: boolean;
  routes: Route[];
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: ViewState;
}

export const defaultViewState: ViewState = {
  columns: [],
  filter: createEmptyFilterModel(),
  range: { endRow: PAGE_SIZE, startRow: 0 },
  sort: [
    {
      field: routeFieldModel.getByName(RouteFieldName.START_AT)!,
      order: SortOrder.ASC,
    },
  ],
};

const initialState: UpcomingViewState = {
  initializing: false,
  loading: false,
  routes: [],
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: defaultViewState,
};

const upcomingView = createReducer<UpcomingViewState, Actions>(initialState)
  .handleAction(initializeUpcomingView.request, () => ({
    ...initialState,
    initializing: true,
  }))
  .handleAction(initializeUpcomingView.success, (state) => ({ ...state, initializing: false }))
  .handleAction(initializeUpcomingView.failure, (state) => ({ ...state, initializing: false }))
  .handleAction(applyUpcomingViewStateSettings, (state, { payload }) => ({
    ...state,
    viewState: { ...state.viewState, ...payload },
  }))
  .handleAction(fetchUpcomingRoutes.request, (state) => ({ ...state, loading: true }))
  .handleAction(fetchUpcomingRoutes.success, (state, { payload }) => ({
    ...state,
    loading: false,
    routes: payload.routes,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchUpcomingRoutes.failure, (state) => ({ ...state, loading: false }));

export type UpcomingViewActions = Actions;
export default upcomingView;
